const HTTP_METHODS = new Set(["get", "post", "put", "patch", "delete", "options", "head"]);
function mapParameter(p) {
    return {
        name: p.name,
        in: (["path", "query", "header", "cookie", "body", "formData"].includes(p.in)
            ? p.in
            : "query"),
        required: typeof p.required === "boolean" ? p.required : false,
        description: typeof p.description === "string" ? p.description : undefined,
        schema: p.schema ?? undefined,
        example: p.example
    };
}
function collectPathLevelParameters(pathItem) {
    if (!Array.isArray(pathItem.parameters)) {
        return [];
    }
    return pathItem.parameters
        .filter((p) => p !== null && typeof p === "object" && typeof p.name === "string")
        .map(mapParameter);
}
export function extractOperations(spec) {
    const paths = spec.paths ?? {};
    return Object.entries(paths).flatMap(([path, pathItem]) => {
        if (!pathItem || typeof pathItem !== "object") {
            return [];
        }
        const pathRecord = pathItem;
        const pathLevelParams = collectPathLevelParameters(pathRecord);
        return Object.entries(pathRecord)
            .filter(([method]) => HTTP_METHODS.has(method.toLowerCase()))
            .map(([method, operation]) => {
            const op = operation;
            const normalizedMethod = method.toUpperCase();
            const operationId = typeof op.operationId === "string" ? op.operationId : "";
            const tags = Array.isArray(op.tags)
                ? op.tags.filter((tag) => typeof tag === "string")
                : [];
            const summary = typeof op.summary === "string" ? op.summary : "No summary";
            const description = typeof op.description === "string" ? op.description : "";
            const key = `${normalizedMethod}:${path}:${operationId}`;
            const searchTextLower = `${path} ${summary} ${tags.join(" ")} ${normalizedMethod}`.toLowerCase();
            const opParams = Array.isArray(op.parameters)
                ? op.parameters
                    .filter((p) => p !== null && typeof p === "object" && typeof p.name === "string")
                    .map(mapParameter)
                : [];
            const parameters = [...pathLevelParams, ...opParams];
            return {
                key,
                method: normalizedMethod,
                path,
                summary,
                operationId,
                tags,
                description,
                parameters,
                requestBody: op.requestBody ?? op.consumes,
                searchTextLower
            };
        });
    });
}
export function operationKey(operation) {
    return `${operation.method}:${operation.path}:${operation.operationId}`;
}
export function detectDefaultServerUrl(spec) {
    const servers = Array.isArray(spec.servers) ? spec.servers : [];
    const first = servers.find((server) => Boolean(server) && typeof server === "object" && typeof server.url === "string");
    if (first) {
        // Fill `{name}` server variables with their declared defaults.
        const variables = first.variables && typeof first.variables === "object" ? first.variables : {};
        return first.url.replace(/\{([^}]+)\}/g, (match, name) => {
            const definition = variables[name];
            return definition && definition.default !== undefined ? String(definition.default) : match;
        });
    }
    if (typeof spec.host === "string") {
        const scheme = Array.isArray(spec.schemes) && typeof spec.schemes[0] === "string" ? spec.schemes[0] : "https";
        const basePath = typeof spec.basePath === "string" ? spec.basePath : "";
        return `${scheme}://${spec.host}${basePath}`;
    }
    return "";
}
//# sourceMappingURL=extract-operations.js.map